/**
 * 该文件为脚本自动生成文件，请勿随意修改。如需修改请联系 PMC
 * */

import { TdRateProps } from './type';

export const rateDefaultProps: TdRateProps = {
  allowHalf: false,
  color: '#ED7B2F',
  count: 5,
  disabled: undefined,
  gap: 8,
  placement: 'top',
  showText: false,
  size: '24px',
  texts: [],
  defaultValue: 0,
};
